export const SERVER_URL = "https://do-calculate.com/api";

export const financialCalculators = [
  {
    name: "حاسبة مكرر الربحية",
    link: "/calculator/ar/pe-ratio/",
    description:
      "حاسبة مكرر الربحية تقوم بحساب مكرر الربحية الخاص بالشركات بناءً على القيمة السوقية للسهم وربحية السهم.",
    showMain: true,
  },
  {
    name: "حاسبة تاثير التضخم على مبلغ",
    link: "/calculator/ar/inflation/",
    description:
      "حاسبة تأثير التضخم تقوم بحساب كمية الأموال التي تفقد قيمتها بسبب التضخم بين فترتين زمنيتين مختلفتين.",
    showMain: true,
  },
  {
    name: "حاسبة جوجل ادسنس",
    link: "/calculator/ar/google-adsense/",
    description:
      "مع هذه الحاسبة لـ جوجل ادسنس نهدف إلى مساعدتك في حساب الإيرادات التي يمكنك الحصول عليها من برنامج جوجل ادسنس.",
    showMain: true,
  },
  {
    name: "حاسبة ضريبة القيمة المضافة",
    link: "/calculator/ar/vat/",
    description:
      "استخدم حاسبة الضريبة لحساب ضريبة المبيعات وضريبة المشتريات والاطلاع على الضريبة الشهرية للأعمال التجارية بكل سهولة ويُمكن القيام بذلك عبر الإنترنت بواسطة حاسبة الضريبة الإلكترونية.",
    showMain: true,
  },
  {
    name: "تحويل العملات - محول العملات",
    link: "/calculator/ar/currency_list/",
    description: "استعرض جميع الحواسب المالية المتاحة للتحويل بين العملات.",
    showMain: true,
  },
  {
    name: "أسعار الذهب اليوم مباشر",
    link: "/calculator/ar/gold-prices/",
    description: "استعرض جميع الحواسب المالية المتاحة للتحويل بين العملات.",
    showMain: true,
  },
  {
    name: "حاسبة صافي المبيعات",
    link: "/calculator/ar/net-sales-calculator/",
    description:
      "احسب صافي المبيعات من إجمالي المبيعات بعد طرح مردودات المبيعات والخصم المسموح به.",
    showMain: true,
  },
  {
    name: "حساب استهلاك الوقود",
    link: "/calculator/ar/fuel-cost-calculator/",
    description:
      "تقوم هذه الحاسبة بحساب كمية الوقود المطلوبة وتكلفتها بناءً على المسافة وكفاءة الوقود وسعر الوقود.",
    showMain: false,
  },
  {
    name: "حساب الخصم",
    link: "/calculator/ar/discount-calculator/",
    description:
      "احسب مقدار الخصم والسعر النهائي بعد تطبيق نسبة الخصم على السعر الإجمالي. توفر هذه الحاسبة طريقة سهلة وسريعة لمعرفة مقدار الخصم والمبلغ الذي ستوفره.",
  },
  {
    name: "حساب اجر الساعة من الراتب الشهري",
    link: "/calculator/ar/hourly-salary-calculator/",
    description:
      "احسب أجر الساعة بناءً على راتبك الشهري وعدد ساعات العمل اليومية. توفر هذه الحاسبة طريقة سهلة وسريعة لمعرفة كم تكسب في الساعة الواحدة.",
  },
  {
    name: "حساب اجر اليوم من الراتب الشهري",
    link: "/calculator/ar/daily-salary-calculator/",
    description:
      "احسب راتبك اليومي بناءً على راتبك الشهري وعدد أيام العمل في الشهر. توفر هذه الحاسبة طريقة سهلة وسريعة لمعرفة كم تكسب في اليوم الواحد.",
  },
  {
    name: "حساب هامش الربح",
    link: "/calculator/ar/profit-margin-calculator/",
    description:
      "احسب الإيرادات والأرباح بناءً على تكلفة المنتج وهامش الربح المطلوب.",
  },
  {
    name: "حساب الزيادة في الراتب",
    link: "/calculator/ar/salary-bonus-calculator/",
    description:
      "استخدم حاسبة الزيادة في الراتب لحساب قيمة الزيادة التي ستحصل عليها بناءً على نسبة مئوية معينة من راتبك الأساسي.",
  }, 
  // paypal-fee
  {
    name: "حاسبة رسوم بايبال",
    link: "/calculator/ar/paypal-fee/",
    description:
      "احسب رسوم بايبال التي ستدفعها عند إرسال أو استلام الأموال عبر منصة بايبال. توفر هذه الحاسبة طريقة سهلة وسريعة لمعرفة مقدار الرسوم التي ستتحملها.",
  },
  // commission-calculator
  {
    name: "حاسبة العمولة",
    link: "/calculator/ar/commission-calculator/",
    description:
      "احسب العمولة التي ستحصل عليها بناءً على نسبة مئوية معينة من المبيعات أو الأرباح. توفر هذه الحاسبة طريقة سهلة وسريعة لمعرفة مقدار العمولة التي ستحصل عليها.",
  },
];
export default financialCalculators;